<script setup lang="ts">
  import { VUserOutlined } from "@krainovsd/vue-icons";
  import { type Component, computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useRoute, useRouter } from "vue-router";
  // import Scale from "@/components/icons/Scale.vue";
  // import Bell from "@/components/icons/Bell.vue";
  import ChartColumn from "@/components/icons/ChartColumn.vue";
  import GitCompare from "@/components/icons/GitCompare.vue";

  type NavItem = {
    name: string;
    icon: Component;
    route: string;
  };

  const { t } = useI18n();

  const router = useRouter();
  const route = useRoute();

  const items: NavItem[] = [
    {
      name: t("navbar.items.statistics", {}, { default: "Стат" }),
      icon: ChartColumn,
      route: "/",
    },
    // {
    //   name: t("navbar.items.reconciliation", {}, { default: "Сверка" }),
    //   icon: Scale,
    //   route: "/reconciliation",
    // },
    {
      name: t("navbar.items.compare", {}, { default: "Сравн." }),
      icon: GitCompare,
      route: "/compare",
    },
    // {
    //   name: t("navbar.items.subscribe", {}, { default: "Подписка" }),
    //   icon: Bell,
    //   route: "/subscription",
    // },
    {
      name: t("navbar.items.account", {}, { default: "Аккаунт" }),
      icon: VUserOutlined,
      route: "/account",
    },
  ];

  const currentRoute = computed(() => route.path);

  function navigate(path: string) {
    void router.push(path);
  }
</script>

<template>
  <nav :class="$style.base">
    <button
      v-for="item in items"
      :key="item.route"
      :class="[$style.item, currentRoute === item.route && $style.item_active]"
      @click="navigate(item.route)"
    >
      <component :is="item.icon" :size="20" :class="$style.icon" />

      <span :class="$style.label">
        {{ item.name }}
      </span>
    </button>
  </nav>
</template>

<style lang="scss" module>
  .base {
    position: fixed;
    bottom: 0;
    left: 0;

    width: 100%;
    height: 57px;

    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 4px;

    background: var(--card-translucent);
    backdrop-filter: saturate(140%) blur(20px);
    border-top: 1px solid var(--border-subtle);

    z-index: 1000;
  }

  .item {
    flex: 1;

    height: 100%;

    border: none;
    background: transparent;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 4px;

    color: var(--muted-foreground);
    font-size: 12px;

    transition:
      color 0.2s ease,
      background 0.2s ease;

    cursor: pointer;

    &_active {
      color: var(--foreground);
      font-weight: 600;
    }
  }

  .icon {
    font-size: 20px;
    line-height: 1;
  }

  .label {
    font-size: 11px;
  }
</style>
